import { useCallback, useEffect, useState } from "react";
import { fetchFounderBrief, FounderBrief } from "../services/founderBriefService";

type FounderBriefState = {
  brief: FounderBrief | null;
  error: string | null;
  isLoading: boolean;
  lastUpdated: Date | null;
  refresh: () => Promise<void>;
};

export function useFounderBrief(): FounderBriefState {
  const [brief, setBrief] = useState<FounderBrief | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [lastUpdated, setLastUpdated] = useState<Date | null>(null);

  const refresh = useCallback(async () => {
    setIsLoading(true);

    try {
      const result = await fetchFounderBrief();
      setBrief(result);
      setError(null);
      setLastUpdated(result.lastUpdated);
    } catch {
      setBrief(null);
      setError("Unable to load Founder Brief.");
      setLastUpdated(new Date());
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return {
    brief,
    error,
    isLoading,
    lastUpdated,
    refresh
  };
}
